import React, { Component } from 'react'
import { connect } from 'react-redux'

import Multi from '../../components/Multi'
import WhiteBox from '../../components/WhiteBox'
import BorderButton from '../../components/BorderButton'

class PublishingScreen extends Component {
    renderLoading() {
        return (
            <Multi>
                <div
                    style={{
                        textAlign: 'center',
                        marginTop: 91
                    }}>
                    <img alt="o" src="/img/preloader.svg" style={{ width: 82, height: 82 }} />
                </div>
                <div
                    style={{
                        textAlign: 'center',
                        marginTop: 91
                    }}>
                    <h2>Publishing License</h2>
                    <p
                        style={{
                            fontSize: 'smaller',
                            color: '#797979'
                        }}>
                        Please wait while we are making your changes available
                    </p>
                </div>
            </Multi>
        )
    }

    renderSuccess(loading, status, statusMessage) {
        let node = null
        if (status === 'SUCCESS') {
            node = (
                <Multi>
                    <div
                        style={{
                            textAlign: 'center',
                            marginTop: 91,
                            color: '#53e69d'
                        }}>
                        <i className="fa fa-check-circle-o" style={{ fontSize: '93.33px' }} />
                    </div>
                    <div
                        style={{
                            textAlign: 'center',
                            marginTop: 91
                        }}>
                        <div>
                            <h2>License OK</h2>
                            <p
                                style={{
                                    fontSize: 'smaller',
                                    color: '#797979'
                                }}>
                                {statusMessage}

                                {/*
                                Your changes are saved
                                */}
                            </p>
                            <div
                                style={{
                                    textAlign: 'center',
                                    marginTop: 90,
                                    display: 'flex',
                                    justifyContent: 'center'
                                }}>
                                <BorderButton
                                    className="white very-blue-bg very-round"
                                    label="ok"
                                    onClick={() => {
                                        this.props.onOK()
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </Multi>
            )
        }

        if (status === 'FAILURE') {
            node = (
                <Multi>
                    <div
                        style={{
                            textAlign: 'center',
                            marginTop: 91,
                            color: 'crimson'
                        }}>
                        <i className="fa fa-times-circle-o" style={{ fontSize: '93.33px' }} />
                    </div>
                    <div
                        style={{
                            textAlign: 'center',
                            marginTop: 91
                        }}>
                        <div>
                            <h2>License ERROR</h2>
                            <p
                                style={{
                                    fontSize: 'smaller',
                                    color: '#797979'
                                }}>
                                {statusMessage}

                                {/*
                            Your changes are saved
                            */}
                            </p>
                            <div
                                style={{
                                    textAlign: 'center',
                                    marginTop: 90,
                                    display: 'flex',
                                    justifyContent: 'center'
                                }}>
                                <BorderButton className="white very-blue-bg very-round" label="ok" onClick={() => {}} />
                            </div>
                        </div>
                    </div>
                </Multi>
            )
        }

        return node
    }

    render() {
        return (
            <Multi>
                <div className="new-license--publish-screen-backdrop" />
                <div className="new-license--publish-screen-wrapper">
                    <WhiteBox>
                        {this.props.saving ? this.renderLoading() : this.renderSuccess(this.props.saving, this.props.status, this.props.statusMessage)}
                    </WhiteBox>
                </div>
            </Multi>
        )
    }
}

export default connect(
    state => ({}),
    {}
)(PublishingScreen)
